// extracted by mini-css-extract-plugin
module.exports = {"past-event":"EventCard-c3eda65b-scss"};